<template>
  <a-col
    :id="'trace-page-video-single' + index"
    :xs="24"
    :sm="24"
    :md="24"
    :lg="12"
    :xl="12"
  >
    <a-card
      size="small"
      hoverable
      style="cursor: auto"
      :body-style="{ display: 'flex' }"
    >
      <!-- <a-row> -->
      <div class="pt-2">
        <img
          v-if="video.isThumbnailExist"
          :id="'trace-page-video-' + index + '-thumbnail'"
          class="clickable video-img"
          :src="thumbnailImage"
          :alt="getFileName(video.fileName)"
          @click="handleVideoPlay"
          @error="handleError(video)"
        />

        <NotFoundImage v-else :alt-url="thumbnailImage" />
      </div>
      <div class="d-flex flex-column pl-3">
        <a-descriptions class="text-start">
          <a-descriptions-item
            label="Cycle Identifier"
            span="3"
            :content-style="{
              display: 'flex',
              alignItems: 'center',
              width: '100% !important',
            }"
            :label-style="{
              display: 'flex',
              alignItems: 'center',
            }"
          >
            <!-- <div class="w-100"> -->
            <a-tag color="blue">
              {{ formatDate(video?.cycle_identifier) }}
            </a-tag>
            <a-tag :key="video.is_good_cycle" :color="getCycleTagColor">
              {{ getCycleTagText }}
            </a-tag>
            <a-space class="ml-auto" size="small">
              <a-tooltip title="Bookmark this video">
                <span>
                  <a-rate
                    :value="Number(video.starred)"
                    style="margin-top: -0.3em; font-size: 1.8em"
                    :count="1"
                    @change="handleBookmark"
                  />
                </span>
              </a-tooltip>
              <a-tooltip title="Copy Video Link">
                <a-button size="small" type="" @click="handleCopyUrl(video)">
                  <template #icon>
                    <i class="bi bi-copy" />
                  </template>
                </a-button>
              </a-tooltip>
              <a-tooltip title="Playback trace video in new tab">
                <a-button
                  size="small"
                  type="primary"
                  @click="goToTraceTab(video)"
                >
                  <template #icon>
                    <i class="bi bi-box-arrow-up-right" />
                  </template>
                </a-button>
              </a-tooltip>
            </a-space>
            <!-- </div> -->
          </a-descriptions-item>
          <a-descriptions-item
            label="Cycle Time"
            class="d-flex align-items-center"
            span="3"
            :label-style="{ width: '6em' }"
          >
            <a-tag color="blue">
              {{ video?.cycle_time }}
            </a-tag>
          </a-descriptions-item>

          <a-descriptions-item
            label="Missed Steps"
            class="d-flex align-items-center"
            span="3"
            :label-style="{ width: '7em' }"
          >
            <a-tag color="blue">
              {{ video.is_good_cycle ? 0 : video?.missedStepsName?.length }}
            </a-tag>
          </a-descriptions-item>
        </a-descriptions>

        <div
          :id="isInterestingCycles ? 'area1-' + index : 'area2-' + index"
          class="d-flex align-items-center"
        >
          <!-- /**
             * Renders a set of buttons for a support user to interact with a video cycle.
             * The buttons allow the user to:
             * - Make the current cycle 'good' or 'bad'
             * - Archive the current cycle
             *
             * The buttons are only displayed if the current user has the 'support_user' role.
             */ -->
          <a-space class="ml-auto" size="small">
            <a-dropdown
              trigger="click"
              placement="bottom"
              :get-popup-container="getPopupContainer"
            >
              <a-button size="small" style="margin-top: 2px">
                Show Missed Steps
                <!-- <template #icon>
                  <DownOutlined />
                </template> -->
              </a-button>

              <template #overlay>
                <a-menu>
                  <a-menu-item
                    v-if="!video.is_good_cycle && video?.missedStepsName.length"
                    v-for="ms in video?.missedStepsName"
                    :key="ms"
                  >
                    {{ ms }}
                  </a-menu-item>
                  <a-menu-item v-else> No missed steps </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
            <a-tooltip title="Show comments">
              <!-- :count="video.no_of_comments" -->
              <a-badge
                :count="video.no_of_comments"
                :overflow-count="10"
                color="#1890ff"
              >
                <a-button
                  size="small"
                  @click="$emit('showComments', true, index)"
                >
                  <!-- <div class="d-flex justify-content-between"> -->

                  <template #icon>
                    <CommentOutlined />
                  </template>
                  <!-- <span>Comments</span>

                <a-tag color="processing" class="ml-3">
                  {{ video.no_of_comments }}
                </a-tag> -->
                  <!-- </div> -->
                </a-button>
              </a-badge>
            </a-tooltip>

            <a-tooltip title="Show tags">
              <a-badge :count="tagsCount" :overflow-count="10" color="#1890ff">
                <a-button size="small" @click="openTagModal">
                  <template #icon>
                    <TagsOutlined />
                  </template>
                </a-button>
              </a-badge>
            </a-tooltip>

            <a-popconfirm
              :title="`Are you sure you want to mark this as a ${
                video?.is_good_cycle == 0 ? 'Good' : 'Bad'
              } cycle?`"
              ok-text="Yes"
              cancel-text="No"
              @confirm="toggleCycleStatus()"
            >
              <a-tooltip
                :title="`Mark as ${
                  video?.is_good_cycle === 0 ? 'Good' : 'Bad'
                }`"
              >
                <a-button size="small">
                  <template #icon>
                    <ToolOutlined />
                  </template>
                </a-button>
              </a-tooltip>
            </a-popconfirm>

            <a-tooltip title="Show Line History">
              <a-button size="small" @click="openLineVisibility">
                <template #icon>
                  <HistoryOutlined />
                </template>
              </a-button>
            </a-tooltip>

            <a-tooltip title="Label Video">
              <a-button size="small" @click="handleClickLabellingTool">
                <template #icon>
                  <EditOutlined />
                </template>
              </a-button>
            </a-tooltip>

            <a-tooltip
              v-if="role == roles.support_user"
              title="Validated Video"
            >
              <a-button size="small">
                <template #icon>
                  <CheckCircleOutlined @click="validateVideoModal(video)" />
                </template>
              </a-button>
            </a-tooltip>

            <a-tooltip v-if="role == roles.support_user" title="Archive cycle">
              <a-popconfirm
                title="Are you sure you want to archive this cycle?"
                ok-text="Yes"
                cancel-text="No"
                @confirm="archiveCycle(video)"
              >
                <a-button size="small" type="danger">
                  <template #icon>
                    <DeleteOutlined />
                  </template>
                </a-button>
              </a-popconfirm>
            </a-tooltip>
          </a-space>
        </div>
      </div>
      <!-- </a-row> -->
    </a-card>
  </a-col>
  <a-modal
    id="assign-group-modal"
    v-model:visible="showAssignGroupModal"
    centered
    :title="selectedFile?.fileName"
    :body-style="{
      height: '15vh',
    }"
    @ok="validateVideo"
  >
    <a-row>
      <a-col :span="24">
        <a-select
          v-model:value="selectedValidateGroup"
          placeholder="Select Group"
          style="width: 100%"
          :options="validateGroupVideos"
        />
      </a-col>
    </a-row>
  </a-modal>

  <a-modal
    id="tags-modal"
    v-model:visible="tagsModal"
    title="Tags"
    :footer="null"
    centered
  >
    <template #closeIcon>
      <close-outlined id="tags-modal-close-btn" />
    </template>
    <div style="height: 30vh">
      <a-list
        class="tags-list"
        size="small"
        item-layout="horizontal"
        :data-source="tags"
        style="flex-grow: 1; max-height: 30vh; overflow-y: auto"
      >
        <template #renderItem="{ item }">
          <a-list-item v-if="item?.tag">
            <a-list-item-meta
              :title="`${item.tag.name} - ${item.step_name}`"
              :description="`${item.added_by}`"
            />
            <div>{{ item.time_stamp }}</div>
          </a-list-item>
        </template>
      </a-list>
    </div>
  </a-modal>
</template>
<script>
import {
  CheckCircleFilled,
  CheckCircleOutlined,
  CloseOutlined,
  CommentOutlined,
  DeleteOutlined,
  EditOutlined,
  HistoryOutlined,
  TagsOutlined,
  ToolOutlined,
} from '@ant-design/icons-vue';
import NotFoundImage from 'src/components/shared/Components/NotFound.vue';
import { roles } from 'src/config/roles-config';
import httpClient from 'src/service/httpClient.js';
import ThumbnailService from 'src/services/thumbnails';
import { getSortedTask } from 'src/utils/task';
import { getThumbnailUrl, traceThumbnail } from 'src/utils/thumbnail.js';
import { mapActions, mapGetters } from 'vuex';
import TelemetryService from '../../../../services/telemetry';
import VideoService from '../../../../services/videos';

export default {
  components: {
    ToolOutlined,
    DeleteOutlined,
    TagsOutlined,
    CommentOutlined,
    NotFoundImage,
    CloseOutlined,
    HistoryOutlined,
    CheckCircleOutlined,
    CheckCircleFilled,
    EditOutlined,
  },
  inject: ['toast'],
  props: [
    'video',
    'cycle',
    'index',
    'isInterestingCycles',
    'goToTraceTab',
    'validateGroupVideos',
  ],
  emits: [
    'updateVideoUrl',
    'handlePlay',
    'showComments',
    'updateVideo',
    'toggleCycleStatus',
    'archivedCycleCount',
    'bookMarkVideo',
    'handleCopyUrl',
    'openLabellingTool',
  ],
  setup() {
    const userId = localStorage.getItem('id');
    const userName = localStorage.getItem('name');
    const organization = localStorage.getItem('organization');
    return { userId, userName, organization };
  },
  data: function () {
    return {
      selectedFile: null,
      selectedValidateGroup: [],
      showAssignGroupModal: false,
      tagOptions: [],
      playable: false,
      document: document,
      queuedThumbnailGenerations: [],
      isThumbnailExist: true,
      thumbnailImage: null,
      roles,
      tagsModal: false,
      isLoadingTag: false,
      currentSelectedTag: [],
      orgTags: [],
      loadingTags: false,
      selectedVideo: null,
      tags: [],
      tagsCount: 0,
      // validateGroupVideos: [],
    };
  },
  computed: {
    ...mapGetters(['selectedTask', 'allTasks', 'organization', 'role']),
    getCycleTagColor() {
      return !this.video.is_good_cycle ? 'error' : 'success';
    },

    getCycleTagText() {
      return !this.video.is_good_cycle ? 'Bad' : 'Good';
    },
  },
  watch: {
    // selectedTask: {
    //   handler: async function (value) {
    //     this.validateGroupVideos = (
    //       await this.groupValidateVideos({ task: value })
    //     ).map((data) => ({
    //       value: data.id,
    //       label: data.name,
    //     }));
    //   },
    //   deep: true,
    // },
    video: {
      handler: function (value) {
        this.thumbnailImage = this.thumbnailUrl(value);
        if (
          !value.isThumbnailExist &&
          !this.isThumbnailGenerationInitiated(value)
        ) {
          this.queuedThumbnailGenerations.push(value.id);
          this.handleThumbnailGeneration(value);
        }
      },
      deep: true,
    },
  },

  async mounted() {
    // this.validateGroupVideos = (
    //   await this.groupValidateVideos({ task: this.selectedTask })
    // ).map((data) => ({
    //   value: data.id,
    //   label: data.name,
    // }));
    this.thumbnailImage = this.thumbnailUrl(this.video);
    this.fetchTags(this.video, false);
  },

  methods: {
    ...mapActions([
      'setNewTags',
      'changeRoute',
      'fetchTaskDetails',
      'groupValidateVideos',
    ]),

    openLineVisibility() {
      this.changeRoute(['Line Visibility']);
      this.$router.push({
        path: '/user/line-visibility',
        query: {
          taskId: this.selectedTask,
          cycleId: this.video.cycle_id,
        },
      });
    },

    handleClickLabellingTool() {
      this.$emit('openLabellingTool', true, this.video);
    },

    formatDate(value) {
      if (!value) return '';

      const date = new Date(value);
      return date.toLocaleString('sv-SE', {
        hour12: false,
        timeZone: 'UTC',
      });
    },
    async toggleCycleStatus() {
      this.$emit('toggleCycleStatus', {
        video: this.video,
        isGoodCycle: !this.video.is_good_cycle,
      });
    },

    filterOption(input, option) {
      return option.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },

    handleBookmark() {
      VideoService.updateTaskRecord(this.video.id, {
        starred: !this.video.starred,
      });

      this.$emit('bookMarkVideo', {
        videoName: this.video.fileName,
        updatedObj: { ...this.video, starred: !this.video.starred },
      });
    },

    handleCopyUrl(data) {
      this.$emit('handleCopyUrl', data);
    },
    toggleShowAssignGroupModal() {
      if (this.showAssignGroupModal) {
        this.selectedFile = null;
        this.showAssignGroupModal = false;
        return;
      }
      this.showAssignGroupModal = !this.showAssignGroupModal;
    },

    async validateVideoModal(video) {
      this.toggleShowAssignGroupModal();
      this.selectedFile = video;
    },

    async validateVideo() {
      // this.toggleShowAssignGroupModal();
      let video = this.selectedFile;

      let tasks = await getSortedTask(this.allTasks);
      let payload = {
        task: this.selectedTask,
        task_name: tasks.find((data) => data.id == this.selectedTask).taskName,
        file_name: video.fileName,
        organization: this.organization,
        isUploadedVideo: false,
        group_id: this.selectedValidateGroup,
        time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        device_id: video.device_id,
      };
      await TelemetryService.markVideoValidate(payload);

      this.$emit('handleUpdateVideo', {
        fileName: video.fileName,
        updatedObj: { is_validation_record: !this.video.is_validation_record },
      });
      this.toggleShowAssignGroupModal();
    },
    isThumbnailGenerationInitiated(video) {
      return this.queuedThumbnailGenerations.includes(video.id);
    },

    async handleThumbnailGeneration(video) {
      const [error] = await this.generateThumbnail(video);
      if (error) {
        return;
      }
      this.$emit('updateVideo', {
        videoName: this.video.fileName,
        updatedObj: { ...this.video, isThumbnailExist: true },
      });
      this.queuedThumbnailGenerations = this.queuedThumbnailGenerations.filter(
        (id) => id !== video.id
      );
    },

    async generateThumbnail(record) {
      const payload = {
        id: record.id,
      };
      return await ThumbnailService.generateThumbnail(payload);
    },

    handleError(video) {
      this.$emit('updateVideo', {
        videoName: video.fileName,
        updatedObj: { ...video, isThumbnailExist: false },
      });
    },

    thumbnailUrl(record) {
      const taskId = this.selectedTask;
      if (!taskId || !this.video || !Object.keys(this.video).length) return;
      const thumbnailPath = traceThumbnail(record, taskId, this.organization);
      return getThumbnailUrl(thumbnailPath);
    },

    getObjectLength() {
      return Object.keys(this.video).length;
    },

    async handleVideoPlay() {
      // console.log('inside handle video play');
      // const { cycle_id, taskId } = this.$route.query;
      // console.log('taskID: ', taskId);
      // this.fetchTaskDetailsNew(Number(taskId));
      this.$emit('handlePlay', {
        video: this.video,
        index: this.index,
      });
    },

    updateVideoUrl(videoName, url) {
      this.$emit('updateVideoUrl', videoName, url, this.index);
    },

    getFileName(filename) {
      let name = filename?.slice(0, 30);
      if (filename?.length > 30) name += '...';
      return name;
    },

    getPopupContainer() {
      const elemId = this.isInterestingCycles
        ? 'area1-' + this.index
        : 'area2-' + this.index;
      return document.getElementById(elemId);
    },

    async archiveCycle(video) {
      await TelemetryService.archiveCycle(video.cycle_id);
      this.emitter.emit('getAnalyticsAndTrace', true);
      this.$emit('archivedCycleCount', video.is_good_cycle);
    },

    openTagModal() {
      this.tagsModal = true;
    },

    async fetchOrgTags() {
      this.isLoadingTag = true;
      const res = await httpClient.get('organization/task_record/tags', false);
      this.orgTags = res;
      this.isLoadingTag = false;
    },

    async handleAddTag(tagId) {
      this.loadingTags = true;
      if (!this.selectedVideo.entity_id) {
        const res = await this.createEntity();
        const temp = { ...this.selectedVideo };
        temp['entity_id'] = res.id;
        this.selectedVideo = temp;
        this.updateTaskRecord(
          { entity_id: this.selectedVideo.entity_id },
          this.selectedVideo,
          false
        );
      }

      const tag_res = await this.createTag(tagId);
      tag_res['tag_name'] = this.orgTags.find(
        (ot) => ot.id === tag_res.tag_name
      );

      let selectedTagName = this.tagOptions.find(
        (data) => data.value == tagId
      ).label;
      this.setNewTags({ tag: tag_res.id, tag_value: selectedTagName });
      this.tags = [...this.tags, { id: tag_res.id, name: selectedTagName }];
      this.loadingTags = false;
      this.fetchTags(this.video);
    },

    async handleTagRemove(tagId) {
      this.loadingTags = true;
      const { entity_id } = this.selectedVideo;
      const entityToDelete = this.tags.find((t) => t.name === tagId);
      if (!entityToDelete) return;

      let [res, data] = await TelemetryService.removeTimeStampTags(
        entityToDelete.id
      );

      if (res === 'error') {
        console.log('error occured while removing tag');
      }

      this.loadingTags = false;
    },

    showTagsModal(data) {
      this.selectedVideo = data.taskRecord;
      this.orgTags = data.orgTags;
      this.tags = data.entityTag;
      this.currentSelectedTag = data.entityTag.map((e) => e.name);
      this.tagOptions = data.orgTags.map((el) => ({
        value: el.id,
        label: el.tag_name,
      }));
      this.tagsModal = true;
    },

    async createEntity() {
      const payload = {
        name: this.selectedVideo.fileName,
        organization: this.organization,
      };
      return await VideoService.createEntityForVideo(payload);
    },

    async fetchTags(record, isShowModal = true) {
      //predefined tags available for particular organization
      const orgTag_response = await httpClient.get(
        `organization/task_record/tags?organization_id=${this.organization}`
      );

      if (!record.entity_id && isShowModal) {
        this.showTagsModal({
          taskRecord: record,
          orgTags: orgTag_response,
          entityTag: [],
        });
      } else {
        const [error, data] = await TelemetryService.getTimeStampTags(
          record.id
        );
        if (error) {
          this.toast.error('Unable to fetch tags!');
          this.isLoading = false;
          return;
        }
        if (isShowModal) {
          this.showTagsModal({
            taskRecord: record,
            orgTags: orgTag_response,
            entityTag: data.map((data) => ({
              id: data.id,
              name: data.tag.name,
            })),
          });
        }
        this.tags = data;
        this.tagsCount = data.length;
      }
    },

    async createTag(tagId) {
      const payload = {
        tag: tagId,
        // entity_id: this.selectedVideo.entity_id,
        added_by: parseInt(this.userId),
        task_record: this.video.id,
        organization: this.organization,
      };

      const [error, data] = await TelemetryService.addTimeStampTags(payload);
      if (error) {
        this.toast.error(`Unable to add ${this.tagIdToNameMap[tag]}!`);
      }

      return data;
      // return await httpClient.post(
      //   `organization/tag_time_stamp_videos_view`,
      //   payload,
      //   false,
      //   false,
      //   false
      // );
    },

    async updateTaskRecord(updatedData, videoToUpdate, alert = true) {
      this.updateVideo(videoToUpdate.fileName, updatedData);
      const [error] = await VideoService.updateTaskRecord(
        videoToUpdate.id,
        updatedData
      );
      if (error && alert) {
        this.toast.success('Error occured while updating the record!');
      }
      if (alert) this.toast.success('Record updated successfully!');
    },

    updateVideo(videoName, updatedObj) {
      if (this.video.fileName === videoName) {
        for (const key in updatedObj) {
          if (updatedObj.hasOwnProperty(key)) {
            this.video[key] = updatedObj[key];
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.video-img {
  /* width: 60%;
  height: 100%; */
  width: 120px;
  height: 120px;
  border-radius: 5px;
}

.rating {
  width: 100%;
  margin-top: 12px;
  justify-content: center;
}
/* 
@media only screen and (max-width: 991px) {
  .video-img {
    height: 240px;
    margin-bottom: 12px;
  }
} */
</style>
